import { render, staticRenderFns } from "./SupportTicketCreateEditModal.vue?vue&type=template&id=04a16e2e"
import script from "./SupportTicketCreateEditModal.vue?vue&type=script&lang=js"
export * from "./SupportTicketCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports